import { lowStock, partyRows, position, recentEntries, salesOn } from '@khata/core';
import { Kpi, PageHead, Row, Empty } from '../components/index.js';
import { dLong, num, qty, taka } from '../lib/format.js';
import { count, t } from '../lib/i18n.js';
import { entries, master, state, today } from '../lib/khata.js';
import { describe } from '../lib/labels.js';
import { openSheet } from '../lib/ui.js';
import { go } from '../lib/router.js';

export function Today() {
  const s = state.value;
  const m = master.value;
  const es = entries.value;
  const tday = today.value;
  const day = salesOn(s, es, tday);
  const pos = position(s, m);
  const owing = partyRows(s, m, 'customer').filter((r) => r.balance > 0).length;
  const owed = partyRows(s, m, 'vendor').filter((r) => r.balance > 0).length;
  const low = lowStock(s, m);
  const recent = recentEntries(s, es, 8);

  return (
    <>
      <PageHead title={t('today_title')} kicker={dLong(tday)} />
      <section class="kpis">
        <Kpi
          label={t('today_sales')}
          value={taka(day.total)}
          sub={count(day.count, 'invoice', 'invoices')}
        />
        <Kpi
          label={t('today_cash')}
          value={taka(pos.cash)}
          sub={`${t('today_bank')} ${taka(pos.bank)}`}
        />
        <Kpi
          label={t('today_recv')}
          value={taka(pos.receivable)}
          sub={count(owing, 'customerOne', 'customerMany')}
          tone={pos.receivable > 0 ? 'bad' : 'ink'}
        />
        <Kpi
          label={t('today_pay')}
          value={taka(pos.payable)}
          sub={count(owed, 'vendorOne', 'vendorMany')}
        />
      </section>
      <section class="actions">
        <button type="button" class="btn btn-primary" onClick={() => openSheet({ kind: 'sale' })}>
          {t('today_newSale')}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          onClick={() => openSheet({ kind: 'purchase' })}
        >
          {t('today_newPurchase')}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          onClick={() => openSheet({ kind: 'payment', direction: 'in' })}
        >
          {t('today_receive')}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          onClick={() => openSheet({ kind: 'payment', direction: 'out' })}
        >
          {t('today_pay_btn')}
        </button>
      </section>
      {low.length > 0 && (
        <section class="section-gap">
          <h6 class="section">
            {t('today_low')} · {num(low.length)}
          </h6>
          <div class="chips">
            {low.slice(0, 12).map((r) => (
              <button
                key={r.item.id}
                type="button"
                class="tag tag-accent-2 clickable"
                onClick={() => openSheet({ kind: 'item', id: r.item.id })}
              >
                {r.item.name} · {qty(r.qty)} {r.item.unit}
              </button>
            ))}
            {low.length > 12 && (
              <button
                type="button"
                class="tag tag-neutral clickable"
                onClick={() => go('stock', 'low')}
              >
                {t('today_moreLow', { n: num(low.length - 12) })}
              </button>
            )}
          </div>
        </section>
      )}
      <section>
        <h6 class="section">{t('today_recent')}</h6>
        <div class="list">
          {recent.length === 0 && <Empty>{t('today_empty')}</Empty>}
          {recent.map((e) => {
            const l = describe(m, e);
            return (
              <Row
                key={e.id}
                title={l.title}
                sub={l.sub}
                amount={l.amount}
                amountTone={l.tone}
                onClick={() => openSheet({ kind: 'entry', id: e.id })}
              />
            );
          })}
        </div>
      </section>
    </>
  );
}
